import { IHierarchyProperty } from "components/hierarchypage/HierarchyProperties";
import { getHierarchyTagInfo } from "functions/getHierarchyTagInfo";
import { eHierarchyLevel } from "./api/enums";
import { checkTag } from "./checkTag";

/**
 * Creates a standardised hierarchy tag property configuration using level-specific labels and validation.
 * Leverages `getHierarchyTagFieldInfo()` to ensure consistent labelling across the application
 * and uses `tagCheck()` for frontend validation of hierarchy tag format and uniqueness.
 *
 * @param level - The hierarchy level (e.g., TA, Project, Study) determining label and validation rules.
 * @param value - The initial value for the property. Defaults to empty string.
 * @returns A fully configured `IHierarchyProperty` object ready for use in hierarchy property collections.
 */
export const createHierarchyTagProperty = (
  level: eHierarchyLevel,
  value: string = "",
): IHierarchyProperty => {
  const tagInfo = getHierarchyTagInfo(level);

  return {
    key: tagInfo.key,
    value,
    type: "hierarchyTag",
    label: tagInfo.label,
    mandatory: true,
    validCondition: checkTag(level, tagInfo.description, tagInfo.validationText),
  };
};
